import React, {Component, Fragment} from 'react';
import * as SignalR from '@aspnet/signalr';
import { v4 as uuidv4 } from 'uuid';

import '../chat.css';
import Setup from '../config/Setup'
import MessageType from '../config/constants/MessageTypeEnum'
import ChatBotChatField from './chatField/ChatBotChatField';
import ChatInput from './chatInput/ChatInput';
import ChatResponseFeedbackEnum from "../config/constants/ChatResponseFeedbackEnum";
import ChatQuestionTypeEnum from "../config/constants/ChatQuestionTypeEnum";
import LineBreakTypeEnum from "../config/constants/LineBreakTypeEnum";
import InfoPage from "./infoPage/InfoPage";
import axios from "axios";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import Localization from "../config/localization/Localization";
import CircularProgress from "@material-ui/core/CircularProgress";
import {isMobile} from "react-device-detect";
import { getLocalizationLanguageCode } from "../util/localization";
import LayoutTypeEnum from "../config/constants/LayoutTypeEnum";
import TopBar from "./topBar/TopBar";
import SearchBotChatField from "./chatField/searchBotChatField/SearchBotChatField";
import MarkdownIt from "markdown-it";
import markdownItCodeCopy from 'markdown-it-code-copy';

/**
 * Class for the chat.
 * Handles the signalR logic for sending and receiving messages.
 */
class Chat extends Component {
  constructor(props) {
    super(props);

    const searchParams = new URLSearchParams(this.props.location.search.toString());
    const chatbotOpenState = (searchParams.get("openState") === 'true');
    const intentId = searchParams.get("intentId");
    const languageParam = searchParams.get("language");


    const token = this.props.match.params.token;
    const userId = this.props.match.params.userId;
    const chatAgentMode = this.props.match.params.chatAgentMode ? true : false;
    const integrationType = this.props.match.params.integrationType ? parseInt(this.props.match.params.integrationType) : null;
    const domain = (document.referrer ?
        document.referrer.toLowerCase().split('/')[2].split(':')[0].trim()
        : (document.location.ancestorOrigins ?  
            document.location.ancestorOrigins[0].toLowerCase().split('/')[2].split(':')[0].trim():null));
    const clientKey = this.props.match.params.clientKey;

    this.state = {
      botWriting: false,
      userWriting: false,
      speechBubbleList: [],
      hubConnection: null,
      connected: false,
      showConnectionLostMsg: false,
      token: token,
      languageParam: languageParam,
      language: this.props.match.params.languageData ? JSON.parse(decodeURIComponent(this.props.match.params.languageData)) : null,
      intentId: intentId,
      chatConfig: null,
      requestedWelcome: false,
      userId: userId,
      chatAgentMode: chatAgentMode,
      integrationType: integrationType,
      forceWelcomeMessage: false,
      startLoad: 0,
      loadMore: false,
      loadToEnd: true,
      showInfoPage: false,
      snackbarErrorMessage: null,
      chatbotOpenState: chatbotOpenState,
      hadFirstClick: false,
      welcomePreviewEnabled: false,
      clientKey: clientKey,
      domain: domain,
      disableConnectionRetry: false,
      trainingPhraseList: [],
      streamIdStopped: [],
      lastStreamId: null,
      isMaximized: false,
      speechBubbleBuffer :[],
      showStopMessage : false,

      isChatMinimized: true
    };

    // Event listener for outside iframe
    const iframeListener = (e) => {

      if (e.data.setchatbotOpenState != null) {
        this.setState({chatbotOpenState: e.data.setchatbotOpenState});

      } else if (e.data.setWelcomePreviewEnabled != null) {
        this.setState({welcomePreviewEnabled: e.data.setWelcomePreviewEnabled});
      }
    };

    try {
      if ('addEventListener' in window) {

        window.addEventListener('message', iframeListener);

      } else if ('attachEvent' in window) { //IE

        window.attachEvent('message', iframeListener);
      }
    } catch (err) {
      console.log(err);
    }
  }

  /**
   * Sends a SignalR message with one available retry after 3 seconds.
   */
  invokeSignalRMessage = (args) => {
    return this.state.hubConnection
        .invoke(...args)
        .catch(err => {
          console.error('Message failed, retrying...');

          setTimeout(() => {
            this.state.hubConnection
                .invoke(...args)
                .catch(err => {
                  console.error(err);
                });
          }, 3000);
        })
  };

  markText = (text) => {
    var md = new MarkdownIt({
      linkify: true,
      html: true,
    }).use(markdownItCodeCopy, {
      iconStyle: "font-size: 21px; opacity: 0.4;",
      iconClass: "mdi content-copy",
      buttonStyle: 'position: absolute; top: 7.5px; right: 6px; cursor: pointer; outline: none;',
      buttonClass: ''
    });

    const defaultRender = md.renderer.rules.link_open || function (tokens, idx, options, env, self) {
      return self.renderToken(tokens, idx, options);
    };

    // Add target="_blank" to external links
    md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
      const aIndex = tokens[idx].attrIndex('target');

      if (aIndex < 0) {
        tokens[idx].attrPush(['target', '_blank']); // add new attribute
      } else {
        tokens[idx].attrs[aIndex][1] = '_blank';    // replace value of existing attr
      }

      // Adding rel="noopener noreferrer"
      const relIndex = tokens[idx].attrIndex('rel');

      if (relIndex < 0) {
        tokens[idx].attrPush(['rel', 'noopener noreferrer']);
      } else {
        tokens[idx].attrs[relIndex][1] = 'noopener noreferrer';
      }

      const hrefIndex = tokens[idx].attrIndex('href');

      if (hrefIndex >= 0) {
        // Fjern parenteser i URL'en
        tokens[idx].attrs[hrefIndex][1] = tokens[idx].attrs[hrefIndex][1].replace(/\(|\)/g, '');
      }

      // pass token to default renderer.
      return defaultRender(tokens, idx, options, env, self);
    };

    let renderedText = md.render(text);
    // Remove the first <p> and the corresponding </p> if they exist
    if (renderedText.startsWith("<p>")) {
      renderedText = renderedText.substring(3);
    }
    if (renderedText.endsWith("</p>\n")) {
      renderedText = renderedText.substring(0, renderedText.length - 5);
    }

    return  renderedText;
  }


  loadMoreSpeechBubble = () => {
    this.setState({loadToEnd : false});
    this.invokeSignalRMessage(['SendChatHistory', this.state.language.id, this.state.startLoad, Setup.messageLoadCount]);
  };

  /**
   * On startup a connection is made to the SignalR hub and event listeners is set up.
   */
  componentDidMount = () => {
    // SignalR connection config.
    const hubConnection = new SignalR.HubConnectionBuilder()
      .withUrl((process.env.NODE_ENV === 'development' ? Setup.apiEndpointDev : process.env.REACT_APP_TEST_BUILD ? Setup.apiEndpointTest : Setup.apiEndpointProd) +
          'chat?token=' + this.state.token + '&userId=' + this.state.userId + '&chatAgentMode=' + this.state.chatAgentMode +
          '&clientKey=' + this.state.clientKey + '&domain=' + this.state.domain)
      .configureLogging(process.env.NODE_ENV === 'development' || process.env.REACT_APP_TEST_BUILD ? SignalR.LogLevel.Debug : SignalR.LogLevel.Error)
      .build();

      // Establishing connection to SignalR hub.
      this.setState({hubConnection}, () => {
        this.startChatConnection();

      // Event listener for when the connection is lost
      this.state.hubConnection.onclose((error) => {
        this.setState({connected: false}, () => {
          setTimeout(() => {
            this.startChatConnection();
          }, Setup.signalrConnectionRetryInterval);
        });
        });

      // Event listener for when the widget should disable retry
      this.state.hubConnection.on('DisableConnectionRetry', () => {
        this.setState({DisableConnectionRetry: true});
        window.parent.postMessage({'hideChatbot': true}, '*');
      });

      // Event listener for when the chat config is recieved.
      this.state.hubConnection.on('ChatConfig', (chatConfig, token) => {
        this.setState({token});
        window.parent.postMessage({'setChatToken': token}, '*');

        hubConnection.connection.baseUrl =  (process.env.NODE_ENV === 'development' ? Setup.apiEndpointDev : process.env.REACT_APP_TEST_BUILD ? Setup.apiEndpointTest : Setup.apiEndpointProd) +
            'chat?token=' + token+ '&userId=' + this.state.userId + '&chatAgentMode=' + this.state.chatAgentMode +
            '&clientKey=' + this.state.clientKey + '&domain=' + this.state.domain;

        if (this.state.chatConfig) {
          return;
        }

        this.setState({chatConfig});

        let language = this.state.language;
        let languageParam = this.state.languageParam;

        // First try to read the language from query parameter.
        if (!language && languageParam) {
          //override e-gb to en - language
          if(languageParam.toLowerCase()  == "en-gb")
          {
            languageParam = "en";
          }
          language = chatConfig.chatConfigLanguageList.find((lang) => {
            return lang.language.languageCode.toLowerCase() === languageParam.toLowerCase() ||
                lang.language.languageCodeShort.toLowerCase() === languageParam.toLowerCase() ||
                lang.language.countryCode.toLowerCase() === languageParam.toLowerCase() ||
                lang.language.name.toLowerCase() === languageParam.toLowerCase();
          }).language;
        }

        // If no language found, set the first language in the chat config as selected.
        if (!language) {
          language = chatConfig.chatConfigLanguageList[0].language;
        }

        this.setState({language}, () => {
          this.invokeSignalRMessage(['SendChatHistory', this.state.language.id, this.state.startLoad, Setup.messageLoadCount]);
        });

        // Inject client html, script and css
        const head = document.getElementsByTagName('head')[0];

        if (chatConfig.clientScript && this.state.userId == null) {
          const clientScriptElement = document.createElement('script');
          clientScriptElement.text = chatConfig.clientScript;

          head.appendChild(clientScriptElement);
        }

        if (chatConfig.clientCss) {
          const clientStyleElement = document.createElement('style');
          clientStyleElement.appendChild(document.createTextNode(chatConfig.clientCss));

          head.appendChild(clientStyleElement);
        }

        if (chatConfig.clientHeaderHtml) {

          const linkElement = document.createElement('link');
          linkElement.href = chatConfig.clientHeaderHtml;
          linkElement.rel = 'stylesheet';

          head.appendChild(linkElement);
        }

        if(chatConfig.soundOnMessageReceived) {
          var x = document.createElement("AUDIO");
          x.id = "audio_messagereceived";
          x.src = "/sound/" + chatConfig.messageReceivedSound;
          x.preload = "auto";
          document.body.appendChild(x);
        }

      });

      // Event listener for when user or chat agent starts or stop writing
      this.state.hubConnection.on('SendUserIsWriting', (isChatAgent, isWriting) => {
        if (isChatAgent) {
          this.setState({botWriting: isWriting});
        } else {
          this.setState({userWriting: isWriting});
        }
      });

      // Event listener for when messages are recieved.
      this.state.hubConnection.on('Send', (chatResponse) => {
        if (this.state.chatbotOpenState === false) {
          const showNewMsgIcon = isMobile ? this.state.chatConfig.showNewMsgIconMobile : this.state.chatConfig.showNewMsgIconDesktop;

          if (showNewMsgIcon) {
            window.parent.postMessage({'showNewMsgIcon': true}, '*');
          }
        }

        this.setState({loadToEnd: true});
        this.handleChatResponse(chatResponse);
      });

      // Event listener when chat history is received
      this.state.hubConnection.on('SendChatHistory', (chatResponseListResult) => {
        let speechBubbleList = this.state.speechBubbleList;

        if(this.state.loadToEnd == false) {
          chatResponseListResult.item2= chatResponseListResult.item2.reverse();
        }

        chatResponseListResult.item2.forEach((chatResponse) => {
          if(this.state.loadToEnd == false)  {
            chatResponse.speechBubbleList=  chatResponse.speechBubbleList.reverse();
          }
             speechBubbleList = this.handleChatResponse(chatResponse, speechBubbleList);
        });

        const startLoadCalc = this.state.startLoad + chatResponseListResult.item2.length;
        const loadMoreCalc = startLoadCalc < chatResponseListResult.item1;

        this.setState({totalCount: chatResponseListResult.item1,startLoad: startLoadCalc, loadMore: loadMoreCalc});

        this.setState({speechBubbleList}, () => {
          if (this.state.requestedWelcome === false && this.state.userId == null) {
            if (this.state.intentId) {
              this.sendIntent(this.state.intentId, ChatQuestionTypeEnum.customIntent);
            } else {
              this.sendWelcome();
            }

            this.setState({requestedWelcome: true});
          }
        });



      });

      // Event listener when a user likes a message
      this.state.hubConnection.on('SendChatResponseFeedback', (chatQuestionId, chatResponseFeedback) => {
        let speechBubbleList = this.state.speechBubbleList;

        const speechBubbleIndex = speechBubbleList.findIndex(sb => sb.chatQuestionId === chatQuestionId);
        if (speechBubbleIndex !== -1) {
          speechBubbleList[speechBubbleIndex].chatResponseFeedback = chatResponseFeedback;

          this.setState({speechBubbleList});
        }
      });

      // Event listener for when mail is sent.
      this.state.hubConnection.on('SendEmail', () => {
        this.setState({botWriting: false});

        let speechBubbleList = this.state.speechBubbleList;

        speechBubbleList.forEach((speechBubble) => {
          if (speechBubble.isMailResponse) {
            speechBubble.hidden = false;
          }
        });

        this.setState({speechBubbleList});
      });

      this.state.hubConnection.on('SendTrainingPhraseList', (trainingPhraseList) => {
        this.setState({trainingPhraseList: trainingPhraseList });
      });
    });

  };

  toggleChatbot = () => {
    this.setState((prevState) => ({
      isChatMinimized: !prevState.isChatMinimized
    }));
  };
  


  handleChatResponse = (chatResponse, speechBubbleList) => {

    if(chatResponse.isStream == true  )
    {
      speechBubbleList = this.state.speechBubbleList;

       if(speechBubbleList!=null && speechBubbleList.length> 0 ) {

        const streamId = chatResponse.speechBubbleList[0].streamId;

         if(this.state.streamIdStopped.some((x) => x  == streamId) )
         {
           return ;
         }

         if(chatResponse.speechBubbleList[0].index > 1) {

           let speechBubbleBuffer = this.state.speechBubbleBuffer;

           speechBubbleBuffer.push(chatResponse.speechBubbleList[0]);

           speechBubbleBuffer = speechBubbleBuffer.sort((a, b) => a.index - b.index);

           let lastSpeechBubble =  speechBubbleList[speechBubbleList.length - 1];

           speechBubbleBuffer.forEach((item, index) => {

            lastSpeechBubble.index = (lastSpeechBubble.index == undefined || lastSpeechBubble.index == 0 ? 1 : lastSpeechBubble.index);

             const indexDiff = item.index - lastSpeechBubble.index;

             if (lastSpeechBubble && (lastSpeechBubble.isUser == undefined || lastSpeechBubble.isUser == false) && lastSpeechBubble.streamId == streamId && (indexDiff == 1) && item.isLastStream == false) {

               const lastSpeechBubbleMsg = lastSpeechBubble.messageList[0];
               const currentSpeechBubbleMsg = item.messageList[0];
               const speechBubbleContent = (lastSpeechBubbleMsg.contentSource ? lastSpeechBubbleMsg.contentSource : lastSpeechBubbleMsg.content) + (currentSpeechBubbleMsg.contentSource ? currentSpeechBubbleMsg.contentSource : currentSpeechBubbleMsg.content);

               speechBubbleList[speechBubbleList.length - 1].messageList[0].contentSource = speechBubbleContent;
               speechBubbleList[speechBubbleList.length - 1].messageList[0].content = this.markText(speechBubbleContent);
               speechBubbleList[speechBubbleList.length - 1].index = item.index;
               speechBubbleList[speechBubbleList.length - 1].isLastStream = item.isLastStream;
               speechBubbleBuffer = speechBubbleBuffer.filter(bufferItem => bufferItem.index !== item.index);

             }

           });

           let showStopMessage = true;

           if(chatResponse.speechBubbleList[0].isLastStream)
           {
             const currentSpeechBubbleContent =  chatResponse.speechBubbleList[0].messageList[0].content;
             speechBubbleList[speechBubbleList.length - 1].messageList[0].contentSource = currentSpeechBubbleContent;
             speechBubbleList[speechBubbleList.length - 1].messageList[0].content = this.markText(currentSpeechBubbleContent);
             speechBubbleList[speechBubbleList.length - 1].isLastStream = true;

             let streamIdStopped = this.state.streamIdStopped;

             streamIdStopped.push(chatResponse.speechBubbleList[0].streamId);

             showStopMessage = false;

             this.setState({streamIdStopped});
           }

           this.setState({
             speechBubbleList: speechBubbleList,
             speechBubbleBuffer: speechBubbleBuffer,
             lastStreamId: streamId,
             showStopMessage,
             botWriting: speechBubbleList[speechBubbleList.length - 1].isLastStream  ||  speechBubbleList[speechBubbleList.length - 1].messageList[0].contentSource == undefined ? false: true
           });

           return;
         }


      }

    }

    let delay = 0;

    const lastNonSuggestionSpeechBubbleIndex = chatResponse.speechBubbleList.map((speechBubble) => {
      return speechBubble.suggestion;
    }).lastIndexOf(null);

    //Id used in internal sorting for search bot layout
    const chatResponseDropId = uuidv4();

    chatResponse.speechBubbleList.forEach((speechBubble, i, array) => {
      // If any delay on speechbubble a 'is writing animation' speechbubble is shown.

      if (speechBubble.delay) {
        delay += speechBubble.delay;
        let botWriting = true;
        this.setState({botWriting});
      }

       if(this.state.loadToEnd == false)
       {
         if (speechBubble.suggestion) {
           speechBubble.hidden = true;
         }
       }

      speechBubble.dropId = chatResponseDropId;
      speechBubble.chatResponseId = chatResponse.id;
      speechBubble.integrationType = chatResponse.integrationType;

      speechBubble.index = i;

      speechBubble.dateTimeUtc = chatResponse.dateTimeUtc;

      // Sets if chat rating buttons should be shown.
      if (chatResponse.chatQuestionId &&
          speechBubble.index === lastNonSuggestionSpeechBubbleIndex &&
          !speechBubble.isUser &&
          speechBubble.lineBreakType !== LineBreakTypeEnum.carousel) {

        speechBubble.chatQuestionId = chatResponse.chatQuestionId;
        speechBubble.chatResponseFeedback = chatResponse.chatResponseFeedback;
      }

      if (speechBubble.index > 0) {
        speechBubble.index -= array.some(speechBubble => speechBubble.isUser) ? 1 : 0;
      }

      // Disables suggestions if in spectatormode.
      if (speechBubble.suggestion && this.state.userId) {
        speechBubble.disabled = true;
      }


    if (speechBubble.isGpt) {
        speechBubble.messageList = speechBubble.messageList.map(message => {
          return { ...message, content: this.markText(message.content) };
        });
      }


      // If state should be updated.
      if (speechBubbleList) {
        if(this.state.loadToEnd) {
         speechBubbleList.push(speechBubble);
       } else
       {
         if(speechBubbleList.find(x=>x.chatQuestionId ==speechBubble.chatQuestionId) == undefined|| speechBubble.id=='00000000-0000-0000-0000-000000000000' || speechBubble.chatQuestionId == null) {
           speechBubbleList.unshift(speechBubble);
         }
       }
      } else {
        // Sets delay on when to show the speechbubble.
        setTimeout(() => {
          speechBubbleList = this.state.speechBubbleList;

          // Hide suggestions if user speechbubble is recieved.
          if (speechBubble.isUser || this.state.loadToEnd == false) {
            speechBubbleList.forEach((sb) => {
              if (sb.suggestion) {
                sb.hidden = true;
              }
            });
          }

          if(this.state.loadToEnd) {
            speechBubbleList.push(speechBubble);
          }else
          {
            if(speechBubbleList.find(x=>x.chatQuestionId ==speechBubble.chatQuestionId) == undefined|| speechBubble.id=='00000000-0000-0000-0000-000000000000' || speechBubble.chatQuestionId == null) {
              speechBubbleList.unshift(speechBubble);
            }
          }

          this.setState({speechBubbleList});

          if (i === array.length - 1 ) {
             let botWriting = false;
            this.setState({botWriting});
           }

        }, delay);

        if(this.state.chatConfig.soundOnMessageReceived && chatResponse.speechBubbleList && chatResponse.speechBubbleList[0] && chatResponse.speechBubbleList[0].avatarName) {
          setTimeout(() => {
            console.log("Play sound: Chat message received (delay = " + speechBubble.delay + ")");
            this.playReceivedMessageSound();
          }, speechBubble.delay);
        }


        // Open chatbot if message is recieved from chat agent.
        if (!this.state.userId && chatResponse && chatResponse.intentId === null) {
          window.parent.postMessage({'openChatbot': true}, '*');
        }
      }
    });



    // close chatbot , action close
    if (!this.state.userId && chatResponse && chatResponse.closeChatbot) {
      window.parent.postMessage({'closeChatbot': true}, '*');
    }


    return speechBubbleList;
  };

  playReceivedMessageSound = () => {
    var audio = document.getElementById("audio_messagereceived");
    audio.play();
  }

  startChatConnection = () => {
    if (this.state.disableConnectionRetry) {
      return;
    }

    this.state.hubConnection.start()
      .then(() => {
        this.setState({connected: true});
        this.setState({showConnectionLostMsg: false})
      }).catch(() => {
        setTimeout(() => {
          this.startChatConnection();
        }, Setup.signalrConnectionRetryInterval);
      });
  };


  getMessageSpeechBubble = (message) => {
    return {
      isUser: true,
      messageList: [
        {
          messageType:  MessageType.text,
          content: message,
        }
      ]
    };
  };

  getFileMessageSpeechBubble = (filename, url) => {
    return {
      isUser: true,
      displayBackground: false,
      messageList: [
        {
          messageType: MessageType.file,
          filename:filename,
          url: url,
          lineBreak: 1
        }
      ]
    };
  };



  sendWelcome = () => {
    this.invokeSignalRMessage(['SendWelcome', this.state.language.languageCode, this.state.forceWelcomeMessage]);
    this.setState({forceWelcomeMessage: false});
  };

  sendUserIsWriting = (isWriting) => {
    this.invokeSignalRMessage(['SendUserIsWriting', isWriting]);
  };

  appendSendMessage = (speechBubble) => {

    this.setState({loadToEnd:true});

    let speechBubbleList = this.state.speechBubbleList;

    if(this.state.lastStreamId!=null)
    {
      let streamIdStopped = this.state.streamIdStopped

      streamIdStopped.push(this.state.lastStreamId);

      this.setState({streamIdStopped});
    }

    // Hides suggestions
    speechBubbleList.forEach((speechBubble) => {
      if (speechBubble.suggestion) {
        speechBubble.hidden = true;
      }
    });

    // Shows a message to the user that looks like they sent it.
    if (speechBubble) {
      speechBubble.lineBreakType = LineBreakTypeEnum.newLine;
      speechBubbleList.push(speechBubble);
    }

    this.setState({speechBubbleList});
  };

  stopMessage = () => {

    let streamIdStopped = this.state.streamIdStopped;

    if (!streamIdStopped.includes(this.state.lastStreamId)) {
      streamIdStopped.push(this.state.lastStreamId);
      this.setState({ streamIdStopped, botWriting: false });
    }
    
    this.setState({ showStopMessage: false });

  }
  /**
   * Gets called when a message is sent from the webclient.
   */
  sendMessage = (message, messageToDisplay, url) => {
    if (this.state.connected === false) {
      this.setState({showConnectionLostMsg: true});
      return false;
    }
    this.setState({loadToEnd: true});


    if (!this.state.userId) {

        const speechBubbleToDisplay = url ? this.getFileMessageSpeechBubble(messageToDisplay,url): this.getMessageSpeechBubble(messageToDisplay);
        this.appendSendMessage(speechBubbleToDisplay);

       this.setState({botWriting: true});

    }
    this.invokeSignalRMessage(['Send', message, this.state.language.languageCode, url, this.state.lastStreamId]);
    return true;
  };

  sendIntent = (intentId, chatQuestionType, messageToDisplay, speechBubble, hideSuggestions, chatMenuItemId) => {
    if (this.state.connected === false) {
      this.setState({showConnectionLostMsg: true});
      return;
    }

    this.setState({loadToEnd: true});

    let speechBubbleToDisplay;

    // Clone speechbubble and show as the user send it.
    if (speechBubble) {
      speechBubbleToDisplay = JSON.parse(JSON.stringify(speechBubble));
      speechBubbleToDisplay.isUser = true;
      speechBubbleToDisplay.index = 0;
      speechBubbleToDisplay.chatResponseId = null;
      speechBubbleToDisplay.suggestion = null;
    } else if (messageToDisplay) {
      speechBubbleToDisplay = this.getMessageSpeechBubble(messageToDisplay);
    }

    this.appendSendMessage(speechBubbleToDisplay);

    // Sends either id of suggestion or chat menu item clicked or null.
    let key = null;
    if (chatQuestionType === ChatQuestionTypeEnum.suggestion) {
      key = speechBubble.suggestion.id;
    } else if (chatQuestionType === ChatQuestionTypeEnum.menuItem) {
      key = chatMenuItemId;
    }

    this.invokeSignalRMessage(['SendIntent', intentId, this.state.language.languageCode, chatQuestionType, key, speechBubbleToDisplay]);
  };

  sendChatAgentIntent = (intentId) => {
    if (this.state.connected === false) {
      this.setState({showConnectionLostMsg: true});
      return false;
    }
    this.invokeSignalRMessage(['SendIntent', intentId, this.state.language.languageCode, ChatQuestionTypeEnum.customIntent, null, null]);
    return true;
  };

  sendChatResponseFeedback = (chatQuestionId, chatResponseFeedback) => {
    if (this.state.connected === false) {
      this.setState({showConnectionLostMsg: true});
      return;
    }

    let speechBubbleList = this.state.speechBubbleList;
    let speechBubble = speechBubbleList.find((sb => {
      return sb.chatQuestionId === chatQuestionId;
    }));

    if (speechBubble) {
      speechBubble.chatResponseFeedback = chatResponseFeedback === ChatResponseFeedbackEnum.notSet ? null : chatResponseFeedback;
    }

    this.setState({speechBubbleList}, () => {
      this.invokeSignalRMessage(['SendChatResponseFeedback', chatQuestionId, chatResponseFeedback]);
    });
  };

  languageSelected = (countryCode) => {
    if (this.state.connected === false) {
      this.setState({showConnectionLostMsg: true});
      return false;
    }

    const language = this.state.chatConfig.chatConfigLanguageList.map(ccl => ccl.language).find((lang) => {
      return lang.countryCode === countryCode;
    });

    window.parent.postMessage({'languageSelected': language.languageCode}, '*');

    this.setState({language, requestedWelcome: false, forceWelcomeMessage: true, speechBubbleList: [], startLoad: 0, trainingPhraseSuggestionList: []}, () => {
      this.invokeSignalRMessage(['SendChatHistory', this.state.language.id , this.state.startLoad, Setup.messageLoadCount]);
    });

    return true;
  };

  getTrainingPhraseList = (searchText) => {
    if (this.state.connected === false) {
      this.setState({showConnectionLostMsg: true});
      return;
    }
    this.invokeSignalRMessage(['GetTrainingPhraseList', searchText, this.state.language.languageCode]);
  };

  getChatResponse = (intentId) => {
    if (this.state.connected === false) {
      this.setState({showConnectionLostMsg: true});
      return;
    }

    return this.invokeSignalRMessage(['GetChatResponse', intentId, this.state.language.languageCode]);
  };

   uploadFileComplete(file, token, callback) {
     this.sendUserIsWriting(true);
     this.setState(this.state.chatAgentMode ? {botWriting: true} : {userWriting: true});

    return axios
        .post((process.env.NODE_ENV === 'development' ? Setup.apiEndpointDev : process.env.REACT_APP_TEST_BUILD ? Setup.apiEndpointTest : Setup.apiEndpointProd) + 'storage/upload/token/' + token , {file})
        .then(response => {
          this.sendUserIsWriting(false);
          this.setState(this.state.chatAgentMode ? {botWriting: false} : {userWriting: false});
             this.sendMessage(file.name, file.name, response.data)
          callback();
        })
        .catch(error => {
          this.setSnackbarErrorMessage(Localization[getLocalizationLanguageCode(this.state.language ? this.state.language.languageCode : null)]['chatInput.chatAttachment.uploadFileError']);
          this.sendUserIsWriting(false);
          this.setState(this.state.chatAgentMode ? {botWriting: false} : {userWriting: false});
          callback();
        })
  }

  toggleShowInfoPage = () => {
    this.setState({showInfoPage: !this.state.showInfoPage});
  };

  closeChatbot = () => {

    this.setState({isMaximized: false});
    window.parent.postMessage({'closeChatbot': true}, '*');

  };

  toggleMaxiChatbot = () => {
    window.parent.postMessage({'toggleMaxiChatbot': true}, '*');

    this.setState({isMaximized: !this.state.isMaximized});
  };

   setSnackbarErrorMessage = (errorMessage) => {
     this.setState({snackbarErrorMessage: errorMessage});
   };

   handleRootClick = () => {
     if (this.state.hadFirstClick === false) {

       if (this.state.welcomePreviewEnabled) {
         window.parent.postMessage({'disableWelcomePreview': true}, '*');
         this.setState({welcomePreviewEnabled: false});
       }

       this.setState({hadFirstClick: true});
     }
   };

   flushTrainingPhraseList = () => {
     this.setState({trainingPhraseList: []})
   }

  render() {

    const chatFieldSpectatorStyle = {
      width: '100%',
      maxWidth: '100%'
    };

    return (
      <div id={'chat-container'} onClick={this.handleRootClick}>

        {this.state.chatConfig ?
            <Fragment>
              <Snackbar
                  anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                  key={`${{vertical: 'top'}},${{horizontal: 'right'}}`}
                  open={this.state.snackbarErrorMessage}
                  onClose={() => { this.setSnackbarErrorMessage(null); }}
                  autoHideDuration={3000}
                  style={{top: '75px'}}
              >
                <MuiAlert elevation={6} variant="filled" severity="error" onClose={() => { this.setSnackbarErrorMessage(null); }}>
                  {this.state.snackbarErrorMessage}
                </MuiAlert>
              </Snackbar>

              <InfoPage language={this.state.language}
                        sendIntent={this.sendIntent}
                        chatConfig={this.state.chatConfig}
                        font={this.state.chatConfig && this.state.chatConfig.font}
                        color={this.state.chatConfig && this.state.chatConfig.topFontColor}
                        backgroundColor={this.state.chatConfig && this.state.chatConfig.topBackgroundColor}
                        gdprLink={this.state.chatConfig && this.state.chatConfig.gdprLink}
                        showInfoPage={this.state.showInfoPage}
                        toggleShowInfoPage={this.toggleShowInfoPage}
              />

              {this.state.userId == null && this.state.chatConfig.layoutMode !== null && this.state.chatConfig.layoutMode === LayoutTypeEnum.searchBot ?
                  <div id={'search-bot-layout'}>
                      <div id={'top-bar-search-bot-container'} style={{display: this.props.welcomePreviewEnabled ? 'none' : null}}>
                        <TopBar  layoutMode={this.state.chatConfig.layoutMode} language={this.state.language} showInfo ={this.state.chatConfig && !this.state.chatConfig.showLogoTop}
                                avatar ={this.state.chatConfig && this.state.chatConfig.logoUrl} name={this.state.chatConfig && this.state.chatConfig.chatbotName}
                                font={this.state.chatConfig && this.state.chatConfig.font}
                                color={this.state.chatConfig && this.state.chatConfig.topFontColor}
                                backgroundColor={this.state.chatConfig && this.state.chatConfig.topBackgroundColor}
                                languageList={this.state.chatConfig && this.state.chatConfig.chatConfigLanguageList ?
                                    this.state.chatConfig.chatConfigLanguageList.map(ccl => ccl.language) : null}
                                languageSelected={this.languageSelected} clientDescription={ this.state.chatConfig && this.state.chatConfig.clientDescription}
                                 enableMaximize={this.state.chatConfig.enableMaximize}  isMaximized ={this.state.isMaximized}  toggleMaxiChatbot ={this.toggleMaxiChatbot} closeChatbot ={this.closeChatbot}  toggleShowInfoPage={this.toggleShowInfoPage} welcomePreviewEnabled={this.state.welcomePreviewEnabled}
                        />
                      </div>
                        <ChatInput
                            uploadFileComplete={(file, callback) => this.uploadFileComplete(file, this.state.token, callback)}
                            handleGetTrainingPhraseList={(text) => this.getTrainingPhraseList(text)}
                            handleGetChatResponse={(intentId) => this.getChatResponse(intentId)}
                            trainingPhraseList={this.state.trainingPhraseList}
                            botWriting={this.state.botWriting}
                            userWriting={this.state.userWriting}
                            chatConfig={this.state.chatConfig}
                            language={this.state.language}
                            sendMessage={this.sendMessage}
                            sendIntent={this.sendIntent}
                            stopMessage={this.stopMessage}
                            showStopMessage={this.state.chatConfig && this.state.chatConfig.gptSetupType == 3 && this.state.showStopMessage}
                            showConnectionLostMsg={this.state.showConnectionLostMsg}
                            sendUserIsWriting={this.sendUserIsWriting}
                            chatAgentMode={this.state.chatAgentMode}
                            integrationType={this.state.integrationType}
                            setSnackbarErrorMessage={this.setSnackbarErrorMessage}
                            handleRootClick={this.handleRootClick}
                            sendChatAgentIntent={this.sendChatAgentIntent}
                            flushTrainingPhraseList={() => this.flushTrainingPhraseList()}
                            disclaimer ={this.state.chatConfig.disclaimer}
                            chatInputText ={this.state.chatConfig.chatInputText}
                            chatInputMax ={this.state.chatConfig.chatInputMax}
                        />
                        <SearchBotChatField
                            token={this.state.token}
                            loadMore={this.state.loadMore}
                            loadToEnd={this.state.loadToEnd}
                            loadMoreSpeechBubble={this.loadMoreSpeechBubble}
                            speechBubbleList={this.state.speechBubbleList}
                            botWriting={this.state.botWriting}
                            userWriting={this.state.userWriting}
                            chatConfig={this.state.chatConfig}
                            sendMessage={this.sendMessage}
                            sendIntent={this.sendIntent}
                            welcomePreviewEnabled={this.state.welcomePreviewEnabled}
                            sendChatResponseFeedback={this.sendChatResponseFeedback}
                            spectatorMode={this.state.userId != null}
                            language={this.state.language}
                        />

                  </div>
                :
                  <div id={'chat-bot-layout'} style={this.props.spectatorMode ? chatFieldSpectatorStyle : null}>

                  {this.state.userId == null ?
                      <Fragment>
                          <div id={'top-bar-shade'} style={{opacity: this.props.welcomePreviewEnabled ? '0.3' : null}}/>

                          <div id={'top-bar-container'} style={{display: this.props.welcomePreviewEnabled ? 'none' : null}}>
                              <TopBar language={this.state.language} showInfo ={this.state.chatConfig && !this.state.chatConfig.showLogoTop}
                                               avatar ={this.state.chatConfig && this.state.chatConfig.logoUrl} name={this.state.chatConfig && this.state.chatConfig.chatbotName}
                                               font={this.state.chatConfig && this.state.chatConfig.font}
                                               color={this.state.chatConfig && this.state.chatConfig.topFontColor}
                                               backgroundColor={this.state.chatConfig && this.state.chatConfig.topBackgroundColor}
                                               languageList={this.state.chatConfig && this.state.chatConfig.chatConfigLanguageList ?
                                                   this.state.chatConfig.chatConfigLanguageList.map(ccl => ccl.language) : null}
                                               languageSelected={this.languageSelected} clientDescription={ this.state.chatConfig && this.state.chatConfig.clientDescription}
                                      enableMaximize={this.state.chatConfig.enableMaximize}  isMaximized ={this.state.isMaximized}  toggleMaxiChatbot ={this.toggleMaxiChatbot} closeChatbot ={this.closeChatbot}  toggleShowInfoPage={this.toggleShowInfoPage} welcomePreviewEnabled={this.state.welcomePreviewEnabled}
                              />
                          </div>
                      </Fragment>
                      : null
                  }

                  <ChatBotChatField token={this.state.token}
                                    loadMore={this.state.loadMore}
                                    loadToEnd={this.state.loadToEnd}
                                    loadMoreSpeechBubble={this.loadMoreSpeechBubble}
                                    speechBubbleList={this.state.speechBubbleList}
                                    botWriting={this.state.botWriting}
                                    userWriting={this.state.userWriting}
                                    chatConfig={this.state.chatConfig}
                                    sendMessage={this.sendMessage}
                                    sendIntent={this.sendIntent}
                                    welcomePreviewEnabled={this.state.welcomePreviewEnabled}
                                    sendChatResponseFeedback={this.sendChatResponseFeedback}
                                    spectatorMode={this.state.userId != null}
                                    language={this.state.language}
                  />

                  {this.state.userId == null || this.state.chatAgentMode === true ?
                      <ChatInput
                          uploadFileComplete={(file, callback) => this.uploadFileComplete(file, this.state.token, callback)}
                          handleGetTrainingPhraseList={(text) => this.getTrainingPhraseList(text)}
                          handleGetChatResponse={(intentId) => this.getChatResponse(intentId)}
                          trainingPhraseList={this.state.trainingPhraseList}
                          botWriting={this.state.botWriting}
                          userWriting={this.state.userWriting}
                          chatConfig={this.state.chatConfig}
                          language={this.state.language}
                          sendMessage={this.sendMessage}
                          sendIntent={this.sendIntent}
                          stopMessage={this.stopMessage}
                          showStopMessage={this.state.showStopMessage}
                          showConnectionLostMsg={this.state.showConnectionLostMsg}
                          sendUserIsWriting={this.sendUserIsWriting}
                          chatAgentMode={this.state.chatAgentMode}
                          integrationType={this.state.integrationType}
                          setSnackbarErrorMessage={this.setSnackbarErrorMessage}
                          handleRootClick={this.handleRootClick}
                          sendChatAgentIntent={this.sendChatAgentIntent}
                          flushTrainingPhraseList={() => this.flushTrainingPhraseList()}
                          disclaimer ={this.state.chatConfig.disclaimer}
                          chatInputText ={this.state.chatConfig.chatInputText}
                          chatInputMax ={this.state.chatConfig.chatInputMax}
                      />
                      : null}
                </div>
              }
            </Fragment> :

            <div id={'chat-loading-container'}>
              <CircularProgress/>
            </div>
        }

      </div>
    );
  }
}

export default Chat;
